const IntroductionSection = () => {
    return (
        <div className="text-center text-[14px] py-[36px] flex flex-col gap-[20px] px-[20px] max-w-[610px] mx-auto">
            <div className="font-semibold">{'PRICING PLAN'}</div>
            <div className="font-semibold text-[24px]">{'Plans that adapt to your search profile'}</div>
            <div>
                <span>{`After talking to hundreds of agents and thousands of private buyers, we have adapted the pricing plans to fit your search preferences`}</span>
            </div>
        </div>
    );
};

export default IntroductionSection;
